import "./style.scss";
export const SecondEdition = () => {
  return (
    <p>
      The Third Edition is a substantially expanded and revised version of{" "}
      <span>The Anatomy of Awakening</span>. It contains extensive footnotes,
      appendices, and supplementary material—forming almost a commentary on the
      root text in places—and may therefore be of interest to specialists or for
      those wishing for more detailed descriptions of this way of practice.
    </p>
  );
};
export const ThirdEditionSinhala = () => {
  return (
    <p>
      This Sinhala translation of the Second Edition is a substantially expanded and revised
      version of <span>The Anatomy of Awakening</span>. It contains extensive
      footnotes, appendices, and supplementary material—forming almost a
      commentary on the root text in places—and may therefore be of interest to
      specialists or for those wishing for more detailed descriptions of this
      way of practice.
    </p>
  );
};
export const AbridgedVersion = () => {
  return (
    <p>
      The Abridged Version comprises the complete root text of{" "}
      <span>The Anatomy of Awakening</span> as it was originally written—without
      footnotes, appendices, or supplementary material—and may be most suitable
      for a reader seeking a complete overview of the path of Buddhist
      meditation but without needing the supporting references, reasoning, and
      details.
    </p>
  );
};
export const ConciseEdition = () => {
  return (
    <p>
      The Concise Meditation Guide contains all of the actual meditation
      instructions in <span>The Anatomy of Awakening</span>—including any
      relevant footnotes and appendices—but does not include the overview of the
      path of insight knowledge or any supplementary material. This booklet
      would be of most benefit for those only requiring a practical meditation
      manual.
    </p>
  );
};
export const DustiOldRagPoems = () => {
  return (
    <p>
      This is a booklet of inspired Dhamma verses. The poems point to the
      spontaneous inner experience, understanding, and outlook of a hermit monk
      on solitary meditation retreat and of a Dhammic relationship with the
      world: thus forming a complimentary work to the more formal teachings
      found in <span>The Anatomy of Awakening</span>.
    </p>
  );
};
export const DustiOldRagPoemsSinhala = () => {
  return (
    <p>
      This Sinhala translation is of a booklet of inspired Dhamma verses. The poems point to the
      spontaneous inner experience, understanding, and outlook of a hermit monk
      on solitary meditation retreat and of a Dhammic relationship with the
      world: thus forming a complimentary work to the more formal teachings
      found in <span>The Anatomy of Awakening</span>.
    </p>
  );
};

export const SecondEditionReprint = () => {
  return (
    <p>
      <span>The Anatomy of Awakening </span> Third Edition zip print file. Page
      margins formatted for sewn bindings. 112 pages. 21.3MB PDF. Cover file
      included (3.1MB PDF).
    </p>
  );
};
export const ThirdEditionReprintSinhala = () => {
  return (
    <p>
      <span>The Anatomy of Awakening </span> Second Edition (Sinhala) zip print
      file. Page margins formatted for sewn bindings. 108 pages. 22.6MB PDF.
      Cover file included (3MB PDF).
    </p>
  );
};
export const ConvergenceOfMapsReprints = () => {
  return (
    <p>
      <span>A Convergence of Maps </span> zip print
      file. Page margins formatted for sewn bindings. 160 pages. 11.1MB PDF.
      Cover files included (3.7MB PDF).
    </p>
  );
};
export const AbridgedVersionReprint = () => {
  return (
    <p>
      <span>The Anatomy of Awakening </span> Abridged Version zip print file.
      Page margins formatted for sewn bindings. 68 pages. 1.6MB PDF. Cover file
      included (2.6MB PDF).
    </p>
  );
};
export const ConciseEditionReprint = () => {
  return (
    <p>
      <span>The Anatomy of Awakening </span> Concise Meditation Guide zip print
      file. Booklet format (stapled spine). 37 pages. 385 KB PDF. Cover file
      Included (2.6MB PDF).
    </p>
  );
};
export const DustiOldRagPoemsReprint = () => {
  return (
    <p>
      <span>The Song of a Dusty Old Rag And Other Poems </span> zip print file.
      Booklet format (stapled spine). 44 pages. 16.3 MB PDF. Cover file Included
      (19.1MB PDF).
    </p>
  );
};
export const DustiOldRagPoemsReprintSinhala = () => {
  return (
    <p>
      <span>The Song of a Dusty Old Rag And Other Poems (Sinhala) </span> zip print file.
      Booklet format (stapled spine). 44 pages. 13.8 MB PDF. Cover files Included.
      Outside (18.6MB PDF) and inside (93 KB).
    </p>
  );
};
